import { render, staticRenderFns } from "./ClaimsModal.vue?vue&type=template&id=2641fe9f&scoped=true&"
import script from "./ClaimsModal.vue?vue&type=script&lang=js&"
export * from "./ClaimsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsModal.vue?vue&type=style&index=0&id=2641fe9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641fe9f",
  null
  
)

export default component.exports